
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managedgroupformlist",
	init: init,
	uninit: uninit,
	listeners: listeners,
	_who: null,
	_group: null,
	_group_tracker: null,
	_loaded: false,

	refresh: refresh,
});

function init() {
	this._group_tracker = this.dispatcher.createTracker();
	this._group = null;
	this._who = null;
	this._loaded = false;
	this.push({});
}

function uninit() {
	this._who = null;
	this._group = null;
	this._loaded = false;
	this._group_tracker.off();
	this._group_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"managedaccount:updated": handle_update,
		"orggroup:updated": handle_org_group_update,
	};
}

function refresh() {
	var managee = this._who;
	var group = this._managegroup;
	if (!managee) return;

	this.emit("save:trigger:start");
	return this.api.manage.forms.listGroup(managee, group) // Get the forms list
		.then(set_forms.bind(this)) // Set _forms on the store
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function set_forms(forms) {
	this.push(forms.reduce(function (result, form) {
		var update = {};
		update[form._id] = form;
		return xtend(result, update);
	}, {}));
}

function handle_update(data) {
	var open = data.open;
	this._managegroup = data.group;
	if (!open) {
		if(this._who){
			this._who = null;
			this._loaded = false;
		}
	} else {
		if(!this._loaded){
			var user = data.data;
			this._who = user._id;
			this._loaded = true;
			this.refresh();
		}
	}
}

function handle_org_group_update(group){
	if(!group) return;
	if(this._group === group) return;
	var tracker = this._group_tracker;
	tracker.off();
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/created", handle_definition_created.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/updated", handle_definition_updated.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/removed", handle_definition_removed.bind(this));
}

function handle_definition_created(definition){
	if(definition.targetType !== "user") return;
	var update = {};
	update[definition._id] = definition;
	this.extend(update);
}

function handle_definition_removed(definition) {
	var copy = xtend(this.data);
	delete copy[definition._id];
	this.push(copy);
}

function handle_definition_updated(definition){
	if(definition.targetType !== "user"){
		var copy = xtend(this.data);
		delete copy[definition._id];
		this.push(copy);
		return;
	}
	var update = {};
	update[definition._id] = definition;
	this.extend(update);
}
